import { render, staticRenderFns } from "./table-assigment.vue?vue&type=template&id=ba57efb2"
import script from "./table-assigment.vue?vue&type=script&lang=js"
export * from "./table-assigment.vue?vue&type=script&lang=js"
import style0 from "./table-assigment.vue?vue&type=style&index=0&id=ba57efb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports